/* avatar-image.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkopb1k%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1qi0%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkolb4i%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17521qr7%20svg%7Bheight%3A8pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l51qr7%20svg%7Bwidth%3A8pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._175216xz%20svg%7Bheight%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l516xz%20svg%7Bwidth%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17521ylp%20svg%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l51ylp%20svg%7Bwidth%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1752zwfg%20svg%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l5zwfg%20svg%7Bwidth%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17521tcg%20svg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l51tcg%20svg%7Bwidth%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17527vkz%20svg%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._w8l57vkz%20svg%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._mkrz1k6g%7Bclip-path%3Apolygon(45%25%201.33975%25%2C46.5798%25%20.60307%25%2C48.26352%25%20.15192%25%2C50%25%200%2C51.73648%25%20.15192%25%2C53.4202%25%20.60307%25%2C55%25%201.33975%25%2C89.64102%25%2021.33975%25%2C91.06889%25%2022.33956%25%2C92.30146%25%2023.57212%25%2C93.30127%25%2025%25%2C94.03794%25%2026.5798%25%2C94.48909%25%2028.26352%25%2C94.64102%25%2030%25%2C94.64102%25%2070%25%2C94.48909%25%2071.73648%25%2C94.03794%25%2073.4202%25%2C93.30127%25%2075%25%2C92.30146%25%2076.42788%25%2C91.06889%25%2077.66044%25%2C89.64102%25%2078.66025%25%2C55%25%2098.66025%25%2C53.4202%25%2099.39693%25%2C51.73648%25%2099.84808%25%2C50%25%20100%25%2C48.26352%25%2099.84808%25%2C46.5798%25%2099.39693%25%2C45%25%2098.66025%25%2C10.35898%25%2078.66025%25%2C8.93111%25%2077.66044%25%2C7.69854%25%2076.42788%25%2C6.69873%25%2075%25%2C5.96206%25%2073.4202%25%2C5.51091%25%2071.73648%25%2C5.35898%25%2070%25%2C5.35898%25%2030%25%2C5.51091%25%2028.26352%25%2C5.96206%25%2026.5798%25%2C6.69873%25%2025%25%2C7.69854%25%2023.57212%25%2C8.93111%25%2022.33956%25%2C10.35898%25%2021.33975%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1rr0%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk7qp0%7Bbackground-color%3Avar(--ds-background-accent-gray-subtler%2C%23dddee1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._i0dl1osq%7Bflex-basis%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zkb7n%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
import { type FC, useEffect, useState } from 'react';
import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import PersonIcon from '@atlaskit/icon/core/person';
import ReleaseIcon from '@atlaskit/icon/core/release';
import { type AppearanceType, type SizeType } from '../types';
interface AvatarImageProps {
  appearance: AppearanceType;
  size: SizeType;
  alt?: string;
  src?: string;
  testId?: string;
  imgLoading?: 'lazy' | 'eager';
}
const styles = {
  image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
  icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
  circle: "_2rko1rr0",
  hexagon: "_mkrz1k6g"
};
const borderRadiusMap = {
  xsmall: "_2rkolb4i",
  small: "_2rkolb4i",
  medium: "_2rko12b0",
  large: "_2rko12b0",
  xlarge: "_2rko1qi0",
  xxlarge: "_2rkopb1k"
};
const nestedSvgStylesMap = {
  xsmall: "_w8l57vkz _17527vkz",
  small: "_w8l51tcg _17521tcg",
  medium: "_w8l5zwfg _1752zwfg",
  large: "_w8l51ylp _17521ylp",
  xlarge: "_w8l516xz _175216xz",
  xxlarge: "_w8l51qr7 _17521qr7"
};

/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */
const AvatarImage: FC<AvatarImageProps> = ({
  alt = '',
  src,
  appearance,
  size,
  testId,
  imgLoading
}) => {
  const [hasImageErrored, setHasImageErrored] = useState(false);

  // If src changes, reset state
  useEffect(() => {
    setHasImageErrored(false);
  }, [src]);
  if (!src || hasImageErrored) {
    let renderedIcon: React.JSX.Element;
    switch (appearance) {
      case 'circle':
        renderedIcon = <PersonIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--person`} spacing="spacious" />;
        break;
      case 'hexagon':
        renderedIcon = <AiAgentIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--agent`} spacing="spacious" />;
        break;
      default: // historical default for safety
      case 'square':
        renderedIcon = <ReleaseIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--ship`} spacing="spacious" />;
        break;
    }
    return <span className={ax([styles.icon, nestedSvgStylesMap[size]])}>{renderedIcon}</span>;
  }
  return <img loading={imgLoading} src={src} alt={alt} data-testid={testId && `${testId}--image`} onError={() => setHasImageErrored(true)} aria-hidden={!alt ? true : undefined} data-vc={testId ? `${testId}--image` : 'avatar-image'} data-ssr-placeholder-ignored className={ax([styles.image, borderRadiusMap[size], appearance === 'circle' && styles.circle, appearance === 'hexagon' && styles.hexagon])} />;
};
export default AvatarImage;